import styled from "styled-components";
import { ScrollableContent } from "../../../talent/talent.styled";

interface QuillContainerProps {
  editing?: boolean;
}
export const QuillContainer = styled.div<QuillContainerProps>`
  width: 100%;

  .header {
    position: relative;
    display: ${({ editing }) => (!!editing ? "none" : "flex")};
    justify-content: space-between;
    align-items: center;
    border-radius: 0.5rem 0.5rem 0 0;
    border: 1px solid #ccc;
    border-bottom: none;
    padding: 0.5rem;
  }

  .footer {
    display: ${({ editing }) => (!!editing ? "none" : "flex")};
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    font-size: .8rem;
    padding: 0.5rem 0;
    font-weight: bold;
  }

  .quill {
    width: 100%;
    background-color: ${({ editing }) => (!editing ? "transparent" : "#fff")} !important;
    border-radius: 0.5rem;
    p {
      font-size: 1rem;
      color: #000;
      margin: 0 !important;
    }
    .ql-toolbar {
      display: ${({ editing }) => (!editing ? "none" : "block")};
      border-radius: 0.5rem 0.5rem 0 0;
      border-bottom: none;

      .ql-formats > button {
        transform: scale(1.2);
        svg {
          filter: invert(50%);
          &:hover {
            filter: invert(60%);
          }
        }
      }

      .ql-formats > span {
        font-size: 1rem;
        text-transform: uppercase;
      }
    }

    .ql-container {
      border-radius: 0 0 0.5rem 0.5rem;
      height: 18rem;

      .ql-editor {
        ${ScrollableContent};
      }
    }
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  padding: 0.5rem;
  background-color: transparent;
  color: #616161;
`;

export const CommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  ${ScrollableContent};
`;

export const Title = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.primaryBlue.main};
  margin-bottom: 1rem;
`;

export const NewCommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 10rem;
`;

export const NewCommentButtonIcon = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  font-size: 2rem;
  background: none;

  svg {
    filter: invert(50%);
    &:hover {
      filter: invert(70%);
    }
  }
`;

export const NewCommentLabel = styled.span`
  color: #aaa;
`;

export const NewCommentButton = styled.button`
  color: ${({ theme }) => theme.colors.primaryBlue.text};
  border: none;
  font-weight: 700;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  background-color: ${({ theme }) => theme.colors.primaryBlue.main};

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryBlue.main};
  }
`;

export const EditorButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  z-index: 10;
`;

const EditorButton = styled.button`
  border: none;
  border-radius: 0.4rem;
  padding: 0.75rem;
  background-color: transparent;
  font-weight: 700;
  transition: 0.3s;
  margin: 0.5rem 0;
`;

export const CancelButton = styled(EditorButton)`
  border: 1px solid ${({ theme }) => theme.colors.primaryBlue.main};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.primaryBlue.main};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.secondaryBlue.main};
    color: ${({ theme }) => theme.colors.secondaryBlue.main};
  }
`;

export const PublishButton = styled(EditorButton)`
  background-color: ${({ theme }) => theme.colors.primaryBlue.main};
  color: ${({ theme }) => theme.colors.primaryBlue.text};

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryBlue.main};
  }

  &:disabled {
    background-color: #dddddd;
    color: #767676;
    cursor: default;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;


export const Subtitle = styled.h3`
  color: ${({ theme }) => theme.colors.primaryBlue.main};
  font-size: 0.8rem;
  align-self: flex-start;
`;